import e from"react";import{getBEMClassName as r}from"@netfront/common-library";const o=({children:o,css:{blockId:m,elementId:t,modifierId:c}})=>e.createElement("div",{className:r(m,t,c)},o);export{o as FormFieldContainer};
//# sourceMappingURL=FormFieldContainer.js.map
